// A linked token's sheet changed on the site (qa-runs 1258; `table:sheet`): a count per token that the hot bar and the
// pickers watch, to read what they read again. A weapon or a spell added moves no number on the token, so nothing else says so.
import { useSyncExternalStore } from 'react';

const counts = new Map<string, number>();
const listeners = new Set<() => void>();

export const sheetPulse = {
  bump(token: string): void { counts.set(token, (counts.get(token) ?? 0) + 1); for (const l of listeners) l(); },
  count: (token: string): number => counts.get(token) ?? 0,
  subscribe(l: () => void): () => void { listeners.add(l); return () => { listeners.delete(l); }; },
};

/** How many times this token's sheet has changed since the page opened. */
export function useSheetPulse(token: string | undefined): number {
  return useSyncExternalStore(sheetPulse.subscribe, () => (token ? sheetPulse.count(token) : 0));
}
